module.exports = __webpack_public_path__ + "static/media/Biometro - topografo.5e4e135f.jpg";